module.exports = __webpack_public_path__ + "static/media/Graphical_abstract-T1D_thb.da4dbe29.jpg";